import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { useToastStore } from "&/toast";
import { issueBrandpayToken } from "~/services/payment/brandpay";

export const Route = createFileRoute("/customer/layout/payment/auth")({
  component: Auth,
});

function Auth() {
  const { add } = useToastStore();
  const navigate = useNavigate();
  const [isProcessing, setIsProcessing] = useState(true);

  useEffect(() => {
    const handleAuth = async () => {
      try {
        // URL 파라미터에서 code와 customerKey 추출
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get("code");
        const customerKey = urlParams.get("customerKey");

        if (!code || !customerKey) {
          throw new Error("인증 정보가 누락되었습니다.");
        }

        console.log("브랜드페이 인증 정보:", { code, customerKey });

        // 서버에서 Access Token 발급 API 호출
        try {
          const tokenData = await issueBrandpayToken({
            code,
            customerKey,
            grantType: "AuthorizationCode",
          });

          console.log("Access Token 발급 성공:", tokenData);
          add("브랜드페이 인증이 완료되었습니다.");

          // 결제 페이지로 리다이렉트
          // paymentData는 세션 스토리지나 URL 파라미터에서 복원 가능
          const paymentData = sessionStorage.getItem("paymentData");
          if (paymentData) {
            navigate({
              to: "/customer/layout/payment",
              search: { paymentData },
            });
          } else {
            // paymentData가 없으면 결제 페이지로 이동 (사용자가 다시 결제 시도)
            navigate({ to: "/customer/layout/payment" });
          }
        } catch (tokenError) {
          console.error("Access Token 발급 실패:", tokenError);
          throw tokenError;
        }
      } catch (error: any) {
        console.error("브랜드페이 인증 실패:", error);
        add(
          error?.message || "브랜드페이 인증에 실패했습니다. 다시 시도해주세요."
        );

        // 에러 시 결제 페이지로 리다이렉트
        setTimeout(() => {
          navigate({ to: "/customer/layout/payment" });
        }, 2000);
      } finally {
        setIsProcessing(false);
      }
    };

    handleAuth();
  }, [add, navigate]);

  return (
    <div className="flex justify-center items-center flex-auto bg-gray-50">
      <div className="text-center">
        <div className="mb-2 text-lg font-semibold">
          {isProcessing ? "브랜드페이 인증 중..." : "인증 완료"}
        </div>
        <div className="text-gray-600">
          {isProcessing ? "잠시만 기다려주세요." : "결제 페이지로 이동합니다."}
        </div>
      </div>
    </div>
  );
}
